import React from "react"
import { DataGrid } from '@mui/x-data-grid';



// Format Columns: { field: 'id', headerName: 'ID', width: 70, type: 'number' }, { field: 'firstName', headerName: 'First name', width: 130 },
// Format Rows: { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },

// See https://mui.com/components/tables/: Data table
// See https://mui.com/api/data-grid/data-grid/: Api


const CustomTable = (props) => {
    return (
    <div style={{ height: 400, width: '100%' }}>
    <DataGrid
      rows={props.data}
      columns={props.columns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      checkboxSelection
    />
  </div>
    );
}

export default CustomTable